import React, { Component } from "react";
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/Modal'
import { Map } from 'immutable';
import { Row, Col, Form, FormInput, Button } from "shards-react";

import { api } from "../../core/api";

import { specialtiesListActions, getCurrentSpecialtiesLists } from "../../core/specialties-lists";
import { locationsListActions, getCurrentLocationsLists } from "../../core/locations-lists";
import { provincesListActions, getCurrentProvincesLists } from "../../core/provinces-lists";
import { efectorActions, createEfector, getEfectorById } from "../../core/efectores";
import { getCurrentEfectorList } from "../../core/efector-lists";
import { isCuitValid,validateEmail, validateName, validateNumbersOnly } from "../../core/helper";
import  LoadingIndicator from '../common/loading-indicator'

const defaultValidations = new Map({
    dni:{
      required:true,
      valid: false,
      invalid: false,
    },
    cuit:{
      required:true,
      valid: false,
      invalid: false,
    },
    nombre:{
      required:true,
      valid: false,
      invalid: false,
    },
    apellido:{
      required:true,
      valid: false,
      invalid: false,
    },
    email:{
      required:true,
      valid: false,
      invalid: false,
    },
    telefono1:{
      required:true,
      valid: false,
      invalid: false,
    },
    telefono2:{
      required:false,
      valid: false,
      invalid: false,
    },
    especialidadId:{
      required:true,
      valid: false,
      invalid: false,
    },
    provinciaId:{
      required:true,
      valid: false,
      invalid: false,
    },
    localidadId:{
      required:true,
      valid: false,
      invalid: false,
    }
})

class EfectorModalForm  extends Component {

  constructor(props) {
    super(props);

    this.state = {
      efector: (props.efector) ? props.efector.toJS() :  { dni: "" },
      is_edit: ( props.efector_id ) ? true:false,
      is_submit: false,
      reset_validation: false,
      validations: defaultValidations.toJS()
    }

    this.loadLocations = this.loadLocations.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.handleClose = this.handleClose.bind(this);


  }

  componentWillMount() {
    const { user, authenticated } = this.props

    if ( authenticated && user.sessionId ){

      this.props.loadProvinces( user.sessionId )
      this.props.loadSpecialties( user.sessionId )
      //this.loadLocations();
      this.loadEfector();
    }

  }

  componentWillUpdate(nextProps, nextState) {
    const { user, authenticated } = this.props

    const { efector } = this.state
    if (authenticated && nextProps.user.sessionId && nextProps.user.sessionId ){

      this.props.loadProvinces( user.sessionId )
      this.props.loadSpecialties( nextProps.user.sessionId )
      this.loadEfector();
    }

    if ( nextProps.efector && !nextProps.efector.isNew && !nextProps.efector.isPending && nextProps.efector.id !== efector.id ){

      this.loadLocations(nextProps.efector.provinciaId);
      this.setState({
        efector: nextProps.efector.toJS(),
        is_edit: ( nextProps.efector.id ) ? true:false,
      });

    }

  }

  componentDidUpdate(oldProps,oldState){
    const { efector, reset_validation  } = this.state
    const { locations, specialties,  provinces, show } = this.props

    /*
    this.select_especialidad.value = efector.especialidadId;
    this.select_provincia.value = efector.provinciaId;
*/
    if ( oldState.efector && efector.provinciaId !== oldState.efector.provinciaId ){
        this.loadLocations();
    }

    if ( specialties && !specialties.isNew && !specialties.isPending && this.select_especialidad && this.select_especialidad.value !== efector.especialidadId )
      this.select_especialidad.value = efector.especialidadId;

    if ( provinces && !provinces.isNew && !provinces.isPending && this.select_provincia && this.select_provincia.value !== efector.provinciaId )
      this.select_provincia.value = efector.provinciaId;

    if ( locations && !locations.isNew && !locations.isPending && this.select_localidad && this.select_localidad.value !== efector.localidadId )
        this.select_localidad.value = efector.localidadId;

    if ( reset_validation ){
      this.setState({
        efector: {},
        validations: defaultValidations.toJS(),
        reset_validation: false
      });
    }

    if ( this.state.is_submit && !this.props.show_popup){
       this.handleClose();
    }
  }

  handleChange(key,event) {

    const { efector } = this.state
    const value = (event.target.validity.valid || event.target.value === "" ) ? event.target.value : efector[key];

    if ( value !== efector[key] ) {

      let _efector = Object.assign({},efector, {
          [key]: value
      })

      if ( key === 'provinciaId' ){
        this.loadLocations(value)
        _efector = Object.assign(_efector, {
            localidadId: ""
        })
      }

      this.setState({
        efector: _efector
      });
      if ( key === 'dni' && value !== "" && value.length > 5 ){
        this.searchEfectorByDNI(value)
      }
    }
  }

  handleBlur(key,event) {
    this.handleValidation(key, event.target.value)
  }

  handleValidation(key, value){

    const { validations } = this.state

    let validation = validations[key];

    validation.message = "";

    if ( validation.required && !value ){

        validation.valid = false;
        validation.invalid = true;
        validation.message = "El campo es obligatorio.";
    }
    else {

      validation.valid = true;
      validation.invalid = false;

      if ( key === 'dni' && !validateNumbersOnly(value) ){
        validation.valid = false;
        validation.invalid = true;
        validation.message = "El campo solo puede contener números.";
      }

      if ( key === 'cuit' && !validateNumbersOnly(value) ){
        validation.valid = false;
        validation.invalid = true;
        validation.message = "El campo solo puede contener números.";
      }
      else if ( key === 'cuit' && !isCuitValid(value) ){
        validation.valid = false;
        validation.invalid = true;
        validation.message = "El CUIT ingresado es invalido.";
      }

      if ( key === 'email' && !validateEmail(value) ){
        validation.valid = false;
        validation.invalid = true;
        validation.message = "Debe ser una dirección de correo válida.";
      }

      if ( key === 'nombre' && !validateName(value) ){
        validation.valid = false;
        validation.invalid = true;
        validation.message = "El campo solo puede contener letras.";
      }

      if ( key === 'apellido' && !validateName(value) ){
        validation.valid = false;
        validation.invalid = true;
        validation.message = "El campo solo puede contener letras.";
      }

    }

    const _validations = Object.assign(validations, {
          [key]: validation
    })

    this.setState({
      validations: _validations,
    });

    return validation;
  }

  handleSave() {
    const { efector } = this.state

    if ( this.validateForm() ){

      if (efector.id)
        this.props.updateEfector(efector)
      else
        this.props.createEfector(efector)

      this.setState({
        is_submit: true
      });
      //  this.handleClose()
    }
  }

  handleClose() {
    const { efector } = this.state

    this.setState({
      reset_validation: true,
      validations: null,
      is_submit: false
    });

    this.props.handleClose()
  }

  validateForm() {

    const { efector  } = this.state

    let error_list = [];

    let result = this.handleValidation('dni', efector.dni)

    if ( !result.valid ) {
        error_list.push("dni");
    }

    result = this.handleValidation('cuit', efector.cuit)
    if ( !result.valid ) {
        error_list.push("cuit");
    }

    result = this.handleValidation('nombre', efector.nombre)
    if ( !result.valid ) {
        error_list.push("nombre");
    }

    result = this.handleValidation('apellido', efector.apellido)
    if ( !result.valid ) {
        error_list.push("apellido");
    }

    result = this.handleValidation('email', efector.email)
    if ( !result.valid ) {
        error_list.push("email");
    }

    result = this.handleValidation('telefono1', efector.telefono1)
    if ( !result.valid ) {
        error_list.push("telefono1");
    }

    result = this.handleValidation('telefono2', efector.telefono2)
    if ( !result.valid ) {
        error_list.push("telefono2");
    }

    result = this.handleValidation('especialidadId', efector.especialidadId)
    if ( !result.valid ) {
        error_list.push("especialidadId");
    }

    result = this.handleValidation('provinciaId', efector.provinciaId)
    if ( !result.valid ) {
        error_list.push("provinciaId");
    }

    result = this.handleValidation('localidadId', efector.localidadId)
    if ( !result.valid ) {
        error_list.push("localidadId");
    }

    result = true;
    if ( error_list.length ) {
      result = false;
    }

    return result;

  }

  searchEfectorByDNI(dni){
    this.props.handleSearchEfectorByDNI(dni)
  }

  loadEfector() {
    if (this.props.efector_id)
      this.props.loadEfector(this.props.efector_id);
  }

  loadLocations(provinciaId){
    const { user } = this.props
    const { efector } = this.state
    this.props.loadLocations(  provinciaId || efector.provinciaId, user.sessionId )
  }

  render()  {
    const { efector, is_edit, validations } = this.state
    const { locations, specialties, provinces, show, displayLoadingIndicator } = this.props


    const specialties_options = specialties ? specialties.items.map( (item, key) => <option key={key} value={item.id}>{item.descripcion}</option>) : null
    const locations_options = locations ? locations.items.map( (item, key) => <option key={key} value={item.id}>{item.nombre}</option>) : null
    const provinces_options = provinces ? provinces.items.map( (item, key) => <option key={key} value={item.id}>{item.nombre}</option>) : null
    if ( !validations )
      return null;

    const css_loading = {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "backgroundColor": "#ffffff",
      "paddingTop": "50%",
    }

    return (
      <Modal
        dialogClassName="modal-md"
        show={show}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ zIndex: 2500 }}
        onHide={() => this.handleClose() }
      >
      <Modal.Header closeButton>
         <h5 className="m-0">
            <i className="far fa-user mr-2"></i> { is_edit ? 'Editar' : 'Agregar Nuevo' } Efector
         </h5>
       </Modal.Header>
       <Modal.Body className="pt-3">
        <Row>
          <Col>

            <Form className={ is_edit ? 'edit-efector' : 'add-new-efector' }>
              <div className="form-row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label htmlFor="userBio" className="mb-1">Nombre</label>
                    <FormInput defaultValue={efector.nombre} id="nombre" onBlur={this.handleBlur.bind(this, 'nombre')} onChange={this.handleChange.bind(this, 'nombre')} required invalid={validations.nombre.invalid} valid={validations.nombre.valid} />
                    <div className="invalid-feedback">{ validations.nombre.message }</div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label htmlFor="userBio" className="mb-1">Apellido</label>
                    <FormInput defaultValue={efector.apellido} id="apellido" onBlur={this.handleBlur.bind(this, 'apellido')} onChange={this.handleChange.bind(this, 'apellido')} required invalid={validations.apellido.invalid} valid={validations.apellido.valid} />
                    <div className="invalid-feedback">{ validations.apellido.message }</div>
                  </div>
                </div>
                <div className="col-12">
                   <div className="form-group">
                      <label htmlFor="userBio" className="mb-1">Especialidad</label>
                      <select className={"form-control custom-select" + (validations.especialidadId.invalid ? ' is-invalid':'' ) + (validations.especialidadId.valid ? ' is-valid':'' ) + ( efector.especialidadId ? ' color-blue':'' ) }
                        defaultValue={efector.especialidadId} ref={e => this.select_especialidad = e}
                        onBlur={this.handleBlur.bind(this, 'especialidadId')}
                        onChange={this.handleChange.bind(this, 'especialidadId')}
                        required >
                        <option value="">Seleccione</option>
                        {specialties_options}
                      </select>
                      <div className="invalid-feedback">{ validations.especialidadId.message }</div>
                  </div>
                </div>
                <div className="col-sm-6">
                    <div className="form-group">
                        <label htmlFor="userBio" className="mb-1">DNI</label>
                        <FormInput id="dni" pattern="[0-9]*" value={efector.dni || ""} onChange={this.handleChange.bind(this, 'dni')} onBlur={this.handleBlur.bind(this, 'dni')}   required invalid={validations.dni.invalid} valid={validations.dni.valid} />
                        <div className="invalid-feedback">{ validations.dni.message }</div>
                    </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label htmlFor="userBio" className="mb-1">CUIT</label>
                    <FormInput defaultValue={efector.cuit} id="cuit" onBlur={this.handleBlur.bind(this, 'cuit')}  onChange={this.handleChange.bind(this, 'cuit')} required invalid={validations.cuit.invalid} valid={validations.cuit.valid} />
                    <div className="invalid-feedback">{ validations.cuit.message }</div>
                  </div>
                </div>
                <div className="col-12">
                    <div className="form-group">
                        <label htmlFor="userBio" className="mb-1">E-mail</label>
                        <FormInput defaultValue={efector.email} id="email" onBlur={this.handleBlur.bind(this, 'email')} onChange={this.handleChange.bind(this, 'email')} required invalid={validations.email.invalid} valid={validations.email.valid} />
                        <div className="invalid-feedback">{ validations.email.message }</div>
                  </div>
                </div>
                <div className="col-sm-6">
                    <div className="form-group">
                        <label htmlFor="userBio" className="mb-1">Teléfono</label>
                        <div className="input-group input-group-seamless">
                           <FormInput value={efector.telefono1 || ""} pattern="[0-9]*" id="telefono" onBlur={this.handleBlur.bind(this, 'telefono1')} onChange={this.handleChange.bind(this, 'telefono1')} required invalid={validations.telefono1.invalid} valid={validations.telefono1.valid} />
                          <div className="invalid-feedback">{ validations.telefono1.message }</div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="form-group">
                        <label htmlFor="userBio" className="mb-1">Teléfono 2</label>
                        <div className="input-group input-group-seamless">
                          <FormInput value={efector.telefono2 || ""} pattern="[0-9]*" id="telefono_1" onBlur={this.handleBlur.bind(this, 'telefono2')} onChange={this.handleChange.bind(this, 'telefono2')} invalid={validations.telefono2.invalid} valid={validations.telefono2.valid} />
                          <div className="invalid-feedback">{ validations.telefono2.message }</div>
                        </div>

                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="form-group">
                        <label htmlFor="userBio" className="mb-1">Provincia</label>
                        <select className={"form-control custom-select" + (validations.provinciaId.invalid ? ' is-invalid':'' ) + (validations.provinciaId.valid ? ' is-valid':'' ) + ( efector.provinciaId ? ' color-blue':'' ) }
                            defaultValue={efector.provinciaId}  ref={e => this.select_provincia = e}
                            onBlur={this.handleBlur.bind(this, 'provinciaId')}
                            onChange={this.handleChange.bind(this, 'provinciaId')}
                            required >
                          <option value="">Seleccione</option>
                             {provinces_options}
                        </select>
                        <div className="invalid-feedback">{ validations.provinciaId.message }</div>
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="form-group">
                        <label htmlFor="userBio" className="mb-1">Localidad</label>
                        <select className={"form-control custom-select" + (validations.localidadId.invalid ? ' is-invalid':'' ) + (validations.localidadId.valid ? ' is-valid':'' ) + ( efector.localidadId ? ' color-blue':'' ) }
                          defaultValue={efector.localidadId}  ref={e => this.select_localidad = e}
                          onBlur={this.handleBlur.bind(this, 'localidadId')}
                          onChange={this.handleChange.bind(this, 'localidadId')}
                          required >
                          <option value="">Seleccione</option>
                          {locations_options}
                        </select>
                        <div className="invalid-feedback">{ validations.localidadId.message }</div>
                    </div>
                </div>
              </div>
            </Form>
            <div className="text-right">
              <Button onClick={this.handleSave.bind(this)} className="ml-auto btn-accent btn-sm m-1">Guardar</Button>
              <Button onClick={ e => this.handleClose() } className="btn-sm">Cancelar</Button>
            </div>

          </Col>
        </Row>
        </Modal.Body>
        { displayLoadingIndicator &&  <div style={css_loading}><LoadingIndicator className="text-center" style={{ "marginTop": "15px", "display": "block" }}/></div> }
      </Modal>

    );
  }
}

EfectorModalForm.defaultProps = {
  efector: createEfector({})
};

//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {

  let  efector = null;
  if (props.data_efector)
    efector = props.data_efector
  else
    efector = getEfectorById(state, props.efector_id)
//console.log(state.efectores.toJS())
  let isPending = false
  if ( efector )
    isPending = efector.isPending

  return {
    user: state.session.user,
    authenticated: state.session.authenticated,
    specialties: getCurrentSpecialtiesLists(state, props),
    provinces: getCurrentProvincesLists(state, props),
    locations: getCurrentLocationsLists(state, props),
    efector_id: props.efector_id,
    efector,
    displayLoadingIndicator: isPending,
    show_popup: state.efectores.get('open_popup')

  }
};

const mapDispatchToProps = {
  loadLocations : locationsListActions.loadLocations,
  loadSpecialties : specialtiesListActions.loadSpecialties,
  loadEfector: efectorActions.loadEfector,
  createEfector: efectorActions.createEfector,
  updateEfector: efectorActions.updateEfector,
  loadProvinces : provincesListActions.loadProvinces,

};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EfectorModalForm);
